// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/bitcoincash-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RawTxVinInnerScriptSig
 */
export interface RawTxVinInnerScriptSig {
    /**
     * 
     * @type {string}
     * @memberof RawTxVinInnerScriptSig
     */
    hex: string;
    /**
     * 
     * @type {string}
     * @memberof RawTxVinInnerScriptSig
     */
    asm: string;
}

/**
 * Check if a given object implements the RawTxVinInnerScriptSig interface.
 */
export function instanceOfRawTxVinInnerScriptSig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hex" in value;
    isInstance = isInstance && "asm" in value;

    return isInstance;
}

export function RawTxVinInnerScriptSigFromJSON(json: any): RawTxVinInnerScriptSig {
    return RawTxVinInnerScriptSigFromJSONTyped(json, false);
}

export function RawTxVinInnerScriptSigFromJSONTyped(json: any, ignoreDiscriminator: boolean): RawTxVinInnerScriptSig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hex': json['hex'],
        'asm': json['asm'],
    };
}

export function RawTxVinInnerScriptSigToJSON(value?: RawTxVinInnerScriptSig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hex': value.hex,
        'asm': value.asm,
    };
}

